// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__7GyJn","description":"styles_description__7s4e7","bone-skeleton":"styles_bone-skeleton__zyqLS"};